import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

const COMPANY_PROFILE_PDF_URL = "https://customer-assets.emergentagent.com/job_e207fe08-869c-4279-b9ff-789e0f1bfe2b/artifacts/y6n7mhsw_HOPE_International_Company_Profile_Rewa_MP.pdf";
const PRODUCT_CATALOGUE_PDF_URL = "https://customer-assets.emergentagent.com/job_e207fe08-869c-4279-b9ff-789e0f1bfe2b/artifacts/99y21fq6_HOPE_International_Product_Catalogue_Rewa_MP.pdf";
const WHATSAPP_MESSAGE = "Hi HOPE INTERNATIONAL, I'm interested in your export products. Please share quotation and product details.";
const WHATSAPP_LINK = `https://wa.me/916267592923?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function ResourcesPage() {
  const resources = [
    {
      title: "Company Profile",
      description: "Complete company overview, mission, vision, certifications & contact details.",
      buttonText: "Download PDF",
      link: COMPANY_PROFILE_PDF_URL,
      testid: "resources-company-profile",
      tag: "Available",
    },
    {
      title: "Product Catalogue",
      description: "Full range of herbal powders with descriptions, packaging & quality info.",
      buttonText: "Download PDF",
      link: PRODUCT_CATALOGUE_PDF_URL,
      testid: "resources-product-catalogue",
      tag: "Available",
    },
    {
      title: "Request COA (Certificate of Analysis)",
      description: "Get batch-specific Certificate of Analysis for any product.",
      buttonText: "Request COA",
      internalLink: "/request-coa",
      testid: "resources-request-coa",
      tag: "On Request",
    },
    {
      title: "Request Specification Sheet",
      description: "Detailed product specifications for nutraceutical & cosmetic R&D.",
      buttonText: "Request Specs",
      internalLink: "/request-coa",
      testid: "resources-request-spec",
      tag: "On Request",
    },
    {
      title: "Packaging Options Brochure",
      description: "Detailed visual brochure of bulk export & retail packaging options.",
      buttonText: "Coming Soon",
      link: null,
      testid: "resources-packaging-soon",
      tag: "Coming Soon",
    },
    {
      title: "Buyer Documentation Checklist",
      description: "Step-by-step import documentation guide for new B2B buyers.",
      buttonText: "Coming Soon",
      link: null,
      testid: "resources-buyer-checklist-soon",
      tag: "Coming Soon",
    },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Resources</h1>
        <p className="page-eyebrow">Pure by Nature. Trusted Worldwide.</p>
        <div className="title-underline"></div>
      </div>

      <div className="page-intro">
        <p>Download key business and product resources for quicker evaluation and purchasing decisions. Batch-specific documentation (COA, MSDS, certificates of origin) is shared per shipment.</p>
      </div>

      <div className="resources-grid-v2">
        {resources.map((resource) => {
          const isComingSoon = resource.tag === "Coming Soon";
          const isInternal = !!resource.internalLink;
          const isExternal = !!resource.link;

          return (
            <div
              key={resource.testid}
              className={`resource-card-v2 ${isComingSoon ? "is-soon" : ""}`}
              data-testid={resource.testid}
            >
              <div className="resource-tag-row">
                <span className={`resource-tag tag-${isComingSoon ? "soon" : (resource.tag === "Available" ? "available" : "request")}`}>
                  {resource.tag}
                </span>
              </div>
              <h3>{resource.title}</h3>
              <p className="resource-desc">{resource.description}</p>
              {isExternal ? (
                <a
                  href={resource.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-download-v2"
                  data-testid={`${resource.testid}-btn`}
                >
                  {resource.buttonText} →
                </a>
              ) : isInternal ? (
                <Link
                  to={resource.internalLink}
                  className="btn-download-v2"
                  data-testid={`${resource.testid}-btn`}
                >
                  {resource.buttonText} →
                </Link>
              ) : (
                <button
                  className="btn-download-v2 disabled"
                  disabled
                  data-testid={`${resource.testid}-btn`}
                >
                  {resource.buttonText}
                </button>
              )}
            </div>
          );
        })}
      </div>

      <div className="page-footer-note">
        <p>If you need a specific document for your import process, please contact us — we'll provide it within 24–48 hours.</p>
      </div>

      <div className="page-cta-section">
        <div className="cta-buttons">
          <Link to="/request-coa" className="btn-primary">Request COA / Specs</Link>
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
            WhatsApp Now
          </a>
        </div>
      </div>
    </div>
  );
}

export default ResourcesPage;
